import type { AllRouteEndpoints } from "../routeTypes";
export const appsBusinessAccountsCacheKeys: AllRouteEndpoints[] = ["/apps/business/accounts_datatable"];
